import { render, staticRenderFns } from "./product_price.vue?vue&type=template&id=a162ead0&scoped=true&"
import script from "./product_price.vue?vue&type=script&lang=js&"
export * from "./product_price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a162ead0",
  null
  
)

export default component.exports